// Hook for toggling active/archive status
export function useToggle(setData, sendActive, sendArchive) {
  const active = async (id, value) => {
    await sendActive(id, value);
    setData((prevData) =>
      prevData.map((item) => {
        if (item.id === id) {
          const key = item.hasOwnProperty("isActive")
            ? "isActive"
            : "isActived";
          return { ...item, [key]: !item[key] };
        }
        return item;
      }),
    );
  };

  const archive = async (id, value) => {
    await sendArchive(id, value);
    setData((prevData) =>
      prevData.map((item) => {
        if (item.id === id) {
          const key = item.hasOwnProperty("isArchived")
            ? "isArchived"
            : "isArchive";
          return { ...item, [key]: !item[key] };
        }
        return item;
      }),
    );
  };

  return { active, archive };
}
